module.exports = __webpack_public_path__ + "static/media/satNormal.69d726bb.png";